<template>
  <!-- TODO: add readonly -->
  <div data-testid="shareable-tags">
    <legend class="col-lg-offset-1 col-lg-10">
      <span>{{ $t('CAMPAIGN_STEP_SHAREABLE_TAGS_HEADER') }}</span>
      <a
        v-tooltip.hover.right="$t('CAMPAIGN_STEP_SHAREABLE_TAGS_MESSAGE')"
        class="m-l-10 f-s-16"
      >
        <i class="fa fa-question-circle"></i>
      </a>
    </legend>
    <div
      v-if="loadingTags"
      class="col-xs-12 col-lg-offset-1"
    >
      <Loader />
    </div>
    <template v-else>
      <div class="form-group row m-b-5" v-if="availableTags">
        <label class="col-sm-3 col-md-3 control-label"
          >{{ $t('CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL') }}
          <a v-tooltip.hover.right="$t(tooltipKey)">
            &nbsp;&nbsp;<i class="fa fa-question-circle"></i>
          </a>
        </label>
        <div class="col-sm-9 col-md-9">
          <NzToggle v-model="localOverrideShareableTags"> </NzToggle>
        </div>
      </div>
      <div class="form-group row m-b-5" v-show="localOverrideShareableTags">
        <label class="col-sm-3 col-md-3 control-label"
          >{{ $t('CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID') }}
          <a
            v-tooltip.hover.right="
              $t('CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID_TT')
            "
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle"></i>
          </a>
        </label>
        <div class="col-sm-9 col-md-9">
          <NzToggle v-model="localShareInboundCallId"> </NzToggle>
        </div>
      </div>
      <CheckBoxTagsTree
        v-if="availableTags && availableTags.length && localOverrideShareableTags"
        :available-tags="availableTags"
        :selected-tags.sync="localMacroTagstoShare"
        :show-selected="true"
      />
    </template>
  </div>
</template>
<script>
import sharedMessages from '@/core/locales';
import messages from './locales';
import NzToggle from '../nzToggle/nzToggle.vue';
import CheckBoxTagsTree from '@/core/components/CheckboxTagsTree/CheckboxTagsTree.vue';
import Loader from '@/core/components/Loader';

export default {
  name: 'ShareableTags',
  components: {
    NzToggle,
    CheckBoxTagsTree,
    Loader
  },
  props: {
    overrideShareableTags: {
      type: Boolean,
    },
    availableTags: {
      type: Array | undefined,
    },
    shareableTagSetting: {
      type: Object,
      default: () => ({}),
    },
    tooltipKey: {
      type: String,
      default: 'CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL_BUYER_TT',
    },
    loadingTags: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localOverrideShareableTags: {
      get() {
        return this.overrideShareableTags;
      },
      set(value) {
        this.$emit('update:overrideShareableTags', value);
      },
    },
    localShareInboundCallId: {
      get() {
        return this.shareableTagSetting?.shareInboundCallId;
      },
      set(value) {
        this.$emit('update:shareableTagSetting', {
          ...this.shareableTagSetting,
          shareInboundCallId: value,
        });
      },
    },
    localMacroTagstoShare: {
      get() {
        return this.shareableTagSetting?.macroTagstoShare;
      },
      set(value) {
        this.$emit('update:shareableTagSetting', {
          ...this.shareableTagSetting,
          macroTagstoShare: value,
        });
      },
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>